import { gql } from "@apollo/client";

export const NOTIFICATIONS_QUERY = gql`
  query NotificationsQuery(
    $eventIds: [NotificationEventId!]
    $limit: Int
    $startCursor: String
  ) {
    me {
      id
      notifications(eventIds: $eventIds, last: $limit, before: $startCursor) {
        pageInfo {
          startCursor
          hasPreviousPage
        }
        edges {
          node {
            id
            created
            ui {
              id
              url
              textForUrl
              message
            }
            eventId
            isRead
          }
        }
      }
      notificationsUnreadCount
    }
  }
`;

export const NOTIFICATION_SUBSCRIPTION = gql`
  subscription NotificationSubscription {
    notification
  }
`;

export const NOTIFICATIONS_MUTATION = gql`
  mutation readNotification($notificationId: SmartID!, $read: Boolean!) {
    readNotification(notificationId: $notificationId, read: $read) {
      notification {
        id
        ui {
          id
          url
          textForUrl
          message
        }
        eventId
        isRead
        created
      }
    }
  }
`;

export const READ_ALL_NOTIFICATION_MUTATION = gql`
  mutation readAllNotifications {
    readAllNotifications {
      notifications {
        id
      }
    }
  }
`;
